import React from 'react';
import {Grid, Row, Col} from 'react-bootstrap';
import { PagePanel } from '../../../components/helpers/PagePanel';
import '../Home.css'
import {ExternalLink} from "../../../components/helpers/EasyLinks";
import {showCFP} from "../../../config";

const About = () => (
    <PagePanel className="transparent information">
        <Grid>
            <Row>
                <Col xs={12} sm={6}>
                    <h1>The Conference</h1>
                    <p className="lead"><strong>GR8Conf</strong> brings you <strong>All Things
                        Groovy</strong></p>
                    <p className="lead">
                        Groovy, Grails, Micronaut, Spock Framework, Geb, Gradle and the related technologies have seen
                        astounding growth in interest and adoption the past few years,
                        and with good reason. To spread the word even more, we created GR8Conf.
                    </p>
                </Col>
                <Col xs={12} sm={6}>
                    <h1>Where and When</h1>
                    <p className="lead">Join us for <strong>three awesome</strong> conference days, mixed with
                        <strong> workshops</strong>, at the <strong>IT-University of Copenhagen </strong>
                        from <strong>May 27th</strong> to <strong>29th</strong>, 2019.</p>

                    <p className="lead">Your source for <strong>All Things Groovy!</strong></p>
                </Col>
                {showCFP && <Col xs={8} xsPush={2}>
                    <h1>The Call for Propsals is open!</h1>
                    <p className="lead">Go to <ExternalLink link="https://cfp.gr8conf.org">cfp.gr8conf.org</ExternalLink> and
                        submit your proposal(s) for GR8Conf 2019 and be part of the awesome speakers line-up!</p>
                </Col>}
            </Row>
        </Grid>
    </PagePanel>);

export default About;



// WEBPACK FOOTER //
// ./src/pages/home/fragments/About.js